import ArrowIcon from "../../../assets/imgs/chevron_right_trede_analyzer.svg";

interface LeagueSettingsItemProps {
  label: string;
  value: string;
}

export default function LeagueSettingsItem({
  label,
  value,
}: LeagueSettingsItemProps) {
  return (
    <div className="flex items-center justify-between mt-2 cursor-pointer">
      <div>
        <span className="text-white text-[12px] font-medium">{label}</span>
      </div>
      <div className="flex items-center gap-3">
        <span className="text-white/80 text-[12px] font-medium">{value}</span>
        <img src={ArrowIcon} alt="ArrowIcon" />
      </div>
    </div>
  );
}
